import { Link } from "react-router-dom";
import { ArrowRight, Shield, Users } from "lucide-react";

export default function Landing() {
    return (
        <div className="public-bg min-h-screen flex flex-col">
            <header className="px-6 py-5 max-w-5xl mx-auto w-full flex items-center justify-between">
                <div className="flex items-center gap-2.5">
                    <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-600 to-emerald-500 flex items-center justify-center text-white font-bold text-sm">P</div>
                    <span className="font-bold tracking-tight">PayGateway</span>
                </div>
            </header>

            <main className="flex-1 flex items-center justify-center px-6 py-12">
                <div className="w-full max-w-3xl">
                    <div className="text-center mb-10">
                        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">Sign in to PayGateway</h1>
                        <p className="mt-2 text-sm text-slate-500">Choose your portal to continue.</p>
                    </div>

                    <div className="grid md:grid-cols-2 gap-4">
                        <Link
                            to="/admin/login"
                            data-testid="land-admin"
                            className="group card card-hover p-6 sm:p-7 ring-1 ring-slate-200 hover:ring-blue-300 transition-all"
                        >
                            <div className="w-11 h-11 rounded-lg bg-blue-50 border border-blue-100 flex items-center justify-center text-blue-700">
                                <Shield className="w-5 h-5" />
                            </div>
                            <div className="mt-4 flex items-center justify-between">
                                <div className="font-semibold text-base">Admin login</div>
                                <ArrowRight className="w-4 h-4 text-slate-400 group-hover:text-blue-600 group-hover:translate-x-0.5 transition-transform" />
                            </div>
                            <div className="text-sm text-slate-500 mt-1">Manage partners, transactions, invoices, and platform-wide settings.</div>
                        </Link>

                        <Link
                            to="/partner/login"
                            data-testid="land-partner"
                            className="group card card-hover p-6 sm:p-7 ring-1 ring-slate-200 hover:ring-emerald-300 transition-all"
                        >
                            <div className="w-11 h-11 rounded-lg bg-emerald-50 border border-emerald-100 flex items-center justify-center text-emerald-700">
                                <Users className="w-5 h-5" />
                            </div>
                            <div className="mt-4 flex items-center justify-between">
                                <div className="font-semibold text-base">Partner login</div>
                                <ArrowRight className="w-4 h-4 text-slate-400 group-hover:text-emerald-600 group-hover:translate-x-0.5 transition-transform" />
                            </div>
                            <div className="text-sm text-slate-500 mt-1">Access your channels, deposits, customers, and team.</div>
                        </Link>
                    </div>
                </div>
            </main>

            <footer className="px-6 py-5 max-w-5xl mx-auto w-full text-[11px] text-slate-400 text-center">
                © PayGateway · Indian P2P infrastructure
            </footer>
        </div>
    );
}
